<template>
	<div class="pagination-view">
		<div :class="[p ? 'spage' : 'dots', p == page ? 'active' : '']" v-for="p in _pages" :key="p" @click="goto(p)">{{ p === null ? '...' : p }}</div>
		<div v-if="count > 0" class="spage" @click="goto(page - 1)" style="margin-left: 20px;">&lt;</div>
		<div v-if="count > 0" class="spage" @click="goto(page + 1)">&gt;</div>
	</div>
</template>

<script>
	export default {
		props: {
			page: {
				type: Number,
				required: true
			},
			count: {
				type: Number,
				required: true
			}
		},
		computed: {
			_pages() {
				let pages = this.count > 0 ? [1] : [];
				let jump = false;				

				for (var i = 1; i < this.count - 1; ++i) {
					if (i >= this.page - 3 && i <= this.page + 1) {
						pages.push(i + 1);
						jump = false;
						continue;
					}

					if (i >= 1 && i < this.count - 1) {
						if (!jump) {
							pages.push(null);
							jump = true;
						}

						continue;
					}

					pages.push(i + 1);
					jump = false;
				}

				if (this.count > 1) {
					pages.push(this.count);
				}

				return pages;
			}
		},
		methods: {
			goto(page) {
				if (page === null || page === this.page || page < 1 || page > this.count) {
					return;
				}

				this.$emit('update:page', page);
			}
		}
	}
</script>

<style lang="scss" scoped>
	$size: 30px;

.pagination-view {
	& > .spage, & > .dots {
		display: inline-block;
		
		height: $size;
		line-height: $size;
		text-align: center;
		padding: 0 10px 0 10px;
		margin-right: 5px;
		font-size: 12px;
		min-width: $size;

		&.spage {
			border: 1px solid #ccc;
			border-radius: calc(#{$size} / 2);
			cursor: pointer;

			&.active {
				background-color: #f7223f;
				color: white;
				border-color: #f7223f;
			}
		}
	}
}
</style>